import { useState, useEffect } from 'react';

import BasicForm from '../basicform/BasicForm.js' ;
import { addNotif } from '../notif.js' ;

const initData = { appointDate: {} } ;
const initRange = { startDate: '', endDate: '' } ;

const DisableForm = ({show}) => {
	const [data, setData] = useState(initData) ;
	const [dates, setDates] = useState([]) ;
	const [empty, setEmpty] = useState(true) ;

	useEffect( () => {
		// fetch('http://localhost:8001/dralistv2',{
		fetch('https://api.draniljainent.com/dralistv2',{
			method : 'get' ,
			headers : { 'Content-Type' : 'application/json' },
		})
		.then(res => {
			if(res.ok)
				return res.json() ;
			throw Error(res.statusText) ;
		})
		.then(data => setDates(data)) 
		.catch(err => console.log(err));
	}, [empty]) ;

	// const formData = [
	// 	[	{type: "calendar2", name: "appointDate", label:"Choose Date of Appointment ", options: dates},
	// 	], [	
	// 		{type: "btn", name: "Disable", style: "sched-btn"},
	// 	],
	// ] ;

	const rangeForm = [
		[
			{type: "date", name: "startDate", label: "Start Date"},
			{type: "date", name: "endDate", label: "End Date"},
		], [
			{type: "btn", name: "Disable Range", style: "sched-btn"},
		],
	] ;

	useEffect(()=>{
		const {flag, appointDate} = data ;

		if(flag === 'yes') {
			// fetch('http://localhost:8001/drav2',{
			fetch('https://api.draniljainent.com/drav2',{
				method : 'post' ,
				headers : { 'Content-Type' : 'application/json' },
				body : JSON.stringify({appointDate, name: 'disabled', mobile: '9999999999', age: 20, gender: 'Male' }) ,
			})
			.then(res => {
				if(res.ok)
					return res.json() ;
				throw Error(res.statusText) ;
			})
			.then(data => {	
				setData(initData) ;
				setEmpty(!empty) ;
				addNotif('Disabled Appointment Successfully', 'success') ;
			}) 
			.catch( err  => {
				console.log(err) ; 
				addNotif('Error While Disabling Appointment' , 'error') ;
			}) ;
		}
		//eslint-disable-next-line
	}, [data])

	// const onDisableClick = (obj) => setData({...obj, flag: 'yes'}) 

	const onRangeSubmit = (formValues) => {

		console.log(formValues) ;
		const { startDate, endDate } = formValues || {} ;
		if(!startDate || !endDate) {
			addNotif('Please select both start and end dates', 'error') ;
			return ;
		}
		// fetch('http://localhost:8001/drdisableDates',{
		fetch('https://api.draniljainent.com/drdisableDates', {
			method: 'post',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ startDate, endDate })
		})
		.then(res => {
			if(res.ok)
				return res.json() ;
			throw Error(res.statusText) ;
		})
		.then(data => {
			console.log(data) ;
			setEmpty(!empty) ;
			addNotif('Disabled date range successfully', 'success') ;
		})
		.catch(err => {
			console.log(err) ;
			addNotif('Error while disabling date range', 'error') ;
		})
	} ;

	if(show !== '')
		return (
			<>
				{/* <BasicForm data={formData} errors={{}} onClick={{"Disable" : onDisableClick}} initData={initData} empty={empty} show={show}/> */}
				<BasicForm data={rangeForm} errors={{}} onClick={{"Disable Range" : onRangeSubmit}} initData={initRange} empty={empty} show={show}/>
			</>
		) ;
	else return null ;
}

export default DisableForm ;